import React, { useState } from 'react';
import { View, Text, TextInput, Switch } from 'react-native';
import styles from '@stylesheet';
import { ValidationType } from '../types/validatorTypes';
import updateStoreHandler from '../utils/updateStoreHandler';
import {Picker } from '@react-native-picker/picker';
import * as Animatable from 'react-native-animatable';
import ComponentRenderer from './ComponentRenderer';
import defaultValComponents, { ValidationComponentType } from '../utils/defaultValComponents';

const DateValidation = ({ item, index }: ValidationType) => {

  // Define an array of configuration objects for each component
  const validationComponents: ValidationComponentType[] = [
    ...defaultValComponents,
    { key: 'dateFormat', label: 'Date Format', type: 'textInput' },
    { key: 'minDate', label: 'Min Date', type: 'textInput' },
    { key: 'maxDate', label: 'Max Date', type: 'textInput' },
    { key: 'allowPastDates', label: 'Allow Past Dates?', type: 'switch' },
    { key: 'allowFutureDates', label: 'Allow Future Dates?', type: 'switch' },
    { key: 'specificDayOfWeek', label: 'Specific Day of Week', type: 'picker' },
    { key: 'restrictWeekends', label: 'Restrict Weekends?', type: 'switch' },
    { key: 'minDays', label: 'Min Days', type: 'textInput', inputMode: 'numeric' },
    { key: 'maxDays', label: 'Max Days', type: 'textInput', inputMode: 'numeric' },
  ];


  return (
    <View style={[styles.validationView, { flexWrap: 'wrap' }]}>
      {validationComponents.map((component) => (
        <View key={component.key} style={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch', position: 'relative', flexWrap: 'wrap' }}>
          {
            component.type === 'switch' &&
            <Text style={{ flex: 1 }}>{component.label}</Text>
          }
          <ComponentRenderer item={item} component={component} index={index} />
        </View>
      ))}
    </View>
  );
};

export default DateValidation;
